import React from "react";

const FilterMobileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M4.29384 2.9209H17.8046L11.0357 11.4257L4.29384 2.9209ZM0.578374 2.39441C3.30755 5.89084 8.34708 12.3707 8.34708 12.3707V20.4706C8.34708 21.213 8.95506 21.8205 9.69816 21.8205H12.4003C13.1434 21.8205 13.7514 21.213 13.7514 20.4706V12.3707C13.7514 12.3707 18.7774 5.89084 21.5066 2.39441C22.1956 1.50342 21.5606 0.220947 20.4392 0.220947H1.64573C0.524331 0.220947 -0.110676 1.50342 0.578374 2.39441Z"
        fill={props.active?"#0085FF":"#C8C8C8"}
      />
    </svg>
  );
};

export default FilterMobileIcon;
